module.exports = __webpack_public_path__ + "static/media/susie.c443d205.jpg";